import { Button, Grid, IconButton, OverflowingTypography, Stack, } from "@vividtheory/minerva-lab";
import { CloseOutline, DoneOutline, ErrorOutline, } from "@vividtheory/minerva-lab/icons";
import React from "react";
import { match } from "ts-pattern";
export var Severity;
(function (Severity) {
    Severity["success"] = "success";
    Severity["error"] = "error";
    Severity["warning"] = "warning";
})(Severity || (Severity = {}));
export const Toast = React.forwardRef(({ title, ctaText, variant = "default", severity = Severity.success, onClick, onClose, }, ref) => {
    return (React.createElement(Grid, { ref: ref, container: true, alignItems: "center", gap: 2, sx: {
            width: (theme) => theme.spacing(85.75),
            maxWidth: (theme) => theme.spacing(85.75),
            breakpoints: {
                xs: {
                    padding: 2,
                },
                md: {
                    padding: 4,
                },
            },
            borderRadius: (theme) => theme.radius.xs5,
            backgroundColor: (theme) => match(severity)
                .with(Severity.error, () => theme.palette.error.main)
                .otherwise(() => theme.palette.surface.main),
            color: (theme) => match(severity)
                .with(Severity.error, () => theme.palette.error.onMain)
                .otherwise(() => theme.palette.surface.onMain),
            boxShadow: (theme) => theme.shadows.md,
        } },
        React.createElement(Grid, { item: true, xs: variant === "default" ? true : 12 },
            React.createElement(Stack, { flexDirection: "row", alignItems: "center", gap: 2 },
                match(severity)
                    .with(Severity.error, () => (React.createElement(ErrorOutline, { size: "sm" })))
                    .otherwise(() => (React.createElement(DoneOutline, { size: "sm" }))),
                React.createElement(OverflowingTypography, { variant: "body3", lineClamp: 2 }, title))),
        ((ctaText && onClick) || onClose) && (React.createElement(Grid, { item: true, xs: variant === "default" ? "auto" : 12 },
            React.createElement(Grid, { container: true, justifyContent: "flex-end", alignItems: "center", flexWrap: "nowrap", gap: 1 },
                ctaText && onClick && (React.createElement(Grid, { item: true },
                    React.createElement(Button, { variant: "minimal", color: "background", invertColors: true, onClick: onClick }, ctaText))),
                onClose && (React.createElement(Grid, { item: true },
                    React.createElement(IconButton, { variant: "minimal", color: "surface", onClick: onClose },
                        React.createElement(CloseOutline, { color: "background", size: "sm" })))))))));
});
//# sourceMappingURL=Toast.js.map